<!-- @veltra/icons generated sha256:c4703ae04db741c1 gen:8 source:src/svg/normal/scan.svg -->
<script setup lang="ts">
defineOptions({ name: 'Scan' })
</script>
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="2"
    viewBox="0 0 24 24"
  >
    <path
      d="M3 7V5a2 2 0 0 1 2-2h2m10 0h2a2 2 0 0 1 2 2v2m0 10v2a2 2 0 0 1-2 2h-2M7 21H5a2 2 0 0 1-2-2v-2m4-5h10"
    />
  </svg>
</template>
